export const API_FORM_LOCALES = {
  'zh-CN': {
    create: '创建',
    update: '保存',
    create_title: '创建',
    update_title: '更新',
    create_success: '创建成功',
    update_success: '更新成功',
    submit: '提交',
    back: '返回',
    no_change: '没有修改',
  },
  'en-US': {
    create: 'Create',
    update: 'Save',
    create_title: 'Create',
    update_title: 'Update',
    create_success: 'Create success',
    update_success: 'Update success',
    submit: 'Submit',
    back: 'Back',
    no_change: 'No change',
  },
};
